export default __webpack_public_path__ + "static/bk-c3ed078acf6cccedbc4f3e459df3e702.webp";